import { advancedRoadmapsPlanPageInitialChecksResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planSetupPageRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planSetupPageRoute.tsx';
import { PORTFOLIO_PLAN_VIEW } from '@jira/platform__observability-capabilities/src/constants.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { expVal } from '@atlassian/jira-feature-experiments';
import SetupPage, { LazyAdvancedRoadmapsSetup } from './ui/setup/index.tsx';

export const planSetupPageRouteEntry: Route = createEntry(planSetupPageRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: SetupPage,
	layout: globalLayout,
	resources: [...getNavigationResources(), advancedRoadmapsPlanPageInitialChecksResource],
	forPaint: [LazyAtlassianNavigation, LazyAdvancedRoadmapsSetup],
	meta: {
		capability: expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)
			? PORTFOLIO_PLAN_VIEW
			: undefined,
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
